import { Component, OnInit } from '@angular/core';
import { CreateFormFrequencyMonthStore } from './create-from-frequency-month.store';
import { ControlValueAccessor, NgControl } from '@angular/forms';
import { MonthsMockStore } from 'src/app/shared/store-mocks/months.store';

@Component({
  selector: 'app-create-form-frequency-month',
  templateUrl: './create-form-frequency-month.component.html',
  styleUrls: ['./create-form-frequency-month.component.scss'],
  providers: [CreateFormFrequencyMonthStore, MonthsMockStore]
})
export class CreateFormFrequencyMonthComponent implements OnInit, ControlValueAccessor {


  constructor(
    public ngControl: NgControl,
    private store: CreateFormFrequencyMonthStore
  ) { 
    ngControl.valueAccessor = this;
  }

  vm$ = this.store.vm$
  value: any = ''

  onChange: any = () => {}
  onTouch: any = () => {}



  ngOnInit(): void {


  }

  writeValue(value: string | undefined){
    if(value){
      this.value = value
    }
  }

  registerOnChange(fn: any){
    this.onChange = fn
  }

  registerOnTouched(fn: any){
    this.onTouch = fn
  }


  frequencyMonthChange(value: any){
    this.modelChange(value)
  }


  modelChange(value: string){
    if(!this.ngControl.touched){
      this.onTouch()
    }

    this.onChange(value)
  }

}
